<template>
  <div class="content-panel">
    <ts-loading-banner :loading="loadingPhoto">
      <form action="">
        <fieldset>
          <legend>{{ $t('thesis.viewAttachmentFile') }}</legend>
          <div
            class="drive-wrapper drive-grid-view"
            style="height: 65vh"
            v-if="files.length > 0"
          >
            <div
              class="grid-items-wrapper ts-overflow-y-auto ts-overflow-x-hidden"
              style="max-height: 65vh"
            >
              <div
                class="drive-item module text-center"
                v-for="(entry, index) in files"
                :key="index"
              >
                <div
                  class="drive-item-inner module-inner ts-cursor-pointer"
                  @dblclick="onOpen(entry.data)"
                >
                  <div class="drive-item-title">
                    <a @click="onOpen(entry.data)">{{
                      entry.data.attributes.original_file_name
                    }}</a>
                    <br />
                    <small class="ts-opacity-5">{{
                      entry.data.attributes.updated_at
                    }}</small>
                  </div>
                  <div class="drive-item-thumb" v-viewer>
                    <!--File Icon-->
                    <a @click="onOpen(entry.data)">
                      <file-icon-thumbnail
                        :entry="entry"
                        :icon-size="iconSize"
                        class="pr-2"
                      />
                    </a>
                  </div>
                </div>
                <div class="drive-item-footer module-footer">
                  <ul class="utilities list-inline">
                    <li>
                      <a
                        class="text-primary"
                        @click.prevent="download(entry.data)"
                        v-tooltip="'Download'"
                        ><i class="fa fa-download"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="text-danger"
                        @click.prevent="remove(entry.data, index)"
                        v-tooltip="'Delete'"
                        ><i class="fa fa-trash"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FileIconThumbnail from './FileIconThumbnail'
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
import PreviewPdfComponent from './preview-pdf'
import * as FileDownload from 'downloadjs'
export default {
  name: 'list-view',
  components: {
    FileIconThumbnail
  },
  data () {
    return {
      iconSize: 'fa-5x',
      loading: false,
      thesis_reg_id: null,
      removing: false,
      id: null,
      loadingPhoto: false,
      view_record: null,

    }
  },
  computed: {
    ...mapState('thesis', ['files'])
  },
  created() {
    this.getCurrentFolder()
  },
  methods: {
    getCurrentFolder () {
      this.loadingPhoto = true
      this.$store
      .dispatch('thesis/getFile', this.thesis_reg_id)
        .finally(() => {
          this.loadingPhoto = false
        })
    },
    async onOpen (data) {
      if (data.type === 'folder') {
        this.$store.commit(
          'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
          data.id
        )
        this.$router.push({
          name: 'file-manager-folder',
          params: { id: data.id }
        })
        this.$emit('fetchCurrentFolder')
      }
      if (data.type === 'video') {
        this.showVideoForm(data.attributes)
      }
      if (data.attributes.file_extension === 'pdf') {
        this.showPdfForm(data.attributes)
      }
      if (data.type === 'image') {
        this.$viewerApi({
          images: [data.attributes.file_storage_path]
        })
      }
      if (
        data.attributes.mime_type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_storage_path)
        }
      }
      if (
        data.attributes.mime_type ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_storage_path)
        }
      }
    },
    showPdfForm (data) {
      this.$modal.show(
        PreviewPdfComponent,
        {
          data: {
            file_storage_path: data.file_storage_path,
            original_file_name: data.original_file_name
          }
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    download (data) {
      FileDownload(data.attributes.file_storage_path)
    },
    async remove (data, index) {
      if (
        await this.$confirmModal.danger(
          'Are you sure to delete' + data.attributes.original_file_name + '?'
        )
      ) {
        this.$store
          .dispatch('thesis/deleteItem', data.attributes.id)
          .then(response => {
            this.$store.commit('thesis/REMOVE_FILE_BY_INDEX', index)
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  }
}
</script>
